import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../api/authService';
import { useNotification } from '../contexts/NotificationContext';

/**
 * Component that requires admin authentication to access routes
 * Redirects to login if not authenticated or not an admin
 */
export default function RequireAdmin({ children }) {
  const location = useLocation();
  const { showError } = useNotification();

  useEffect(() => {
    // Check if user has admin access
    if (!authService.isAuthenticated()) {
      console.log('RequireAdmin: User not authenticated');
      return;
    }
    
    const isAdmin = authService.isAdmin();
    console.log('RequireAdmin: Admin check result:', isAdmin);
    
    if (!isAdmin) {
      console.log('RequireAdmin: Access denied - user is not admin (is_admin = false)');
      showError('Access Denied', 'Admin privileges required to access this page');
    }
  }, [showError]);

  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    console.log('RequireAdmin: Redirecting to login - not authenticated');
    // Redirect to login, saving the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user is admin
  if (!authService.isAdmin()) {
    console.log('RequireAdmin: Redirecting to home - user is not admin');
    // Redirect to home if not admin
    return <Navigate to="/" replace />;
  }

  console.log('RequireAdmin: Access granted - user is admin');
  // User is authenticated and is admin, render the requested component
  return children;
}